import {createSimpleAction} from "../utils/actionUtils";

export const LOAD_KUNDEN_TERMINE = 'LOAD_KUNDEN_TERMINE'
export const loadKundenTermineAction = createSimpleAction(LOAD_KUNDEN_TERMINE, 'kundId')

export const LOAD_KUNDEN_TERMINE_SUCCESS = 'LOAD_KUNDEN_TERMINE_SUCCESS'
export const loadKundenTermineSuccessAction = createSimpleAction(LOAD_KUNDEN_TERMINE_SUCCESS, 'data')